import * as React from 'react';
import './index.css'
import { useLiveOperation } from "../../userHooks";
import { useJSBridgeAction } from "@realsee/jsbridge-x/lib/react/hooks";
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close';
import { Box, Input } from "@mui/material";
import CallIcon from '@mui/icons-material/Call';
import EntryButton from "../_ui/EntryButton";

const entryFlag = window.location.search.includes('userRole=audience')

const DefaultSpaceUserModeLayout = () => {
    const { liveConnect, liveConnectFromUrl } = useLiveOperation()
    const { closeWebView } = useJSBridgeAction()
    const liveUrlRef = React.createRef()
    
    function handleClose() {
        Promise.resolve().then(() => closeWebView())
    }
    
    function onLiveOpen() {
        if(!liveUrlRef.current.value) {
            console.log('输入有误')
            return
        }
        liveConnectFromUrl(liveUrlRef.current.value)
    }

    return <div className='default__user'>
        <div className="gui__top" >
            <div className="gui__top--bar">
                {/*<IconButton onClick={handleClose} className="close btn" sx={{color: 'white', pointerEvents: 'auto'}}><CloseIcon/></IconButton>*/}
                <IconButton className="title btn" sx={{color: 'white', fontSize: '16px'}}>如视开发者中心示例--user态</IconButton>
                {/*<IconButton></IconButton>*/}
            </div>
        </div>
        <div className="gui__overlay">
            {/* 一些面板 */}
            <div className="scene-overlay">
            
            </div>
        </div>
        <div className="gui__bottom">
            <div className='controls'>
             <div className='collapsible-list'>
                 <div className='collapsible-item'>
                     {
                         entryFlag
                             ? <Box>
                                 <Input type="text" placeholder="请输入带看链接" inputRef={liveUrlRef} />
                                 <IconButton
                                     sx={{color: 'white'}}
                                     onClick={onLiveOpen}
                                 ><CallIcon /></IconButton>
                             </Box>
                             : <Box
                                 className='live--open'
                                 onClick={() => liveConnect()}
                                 sx={{display: 'flex', justifyContent: 'center'}}
                             ><EntryButton text='进入带看'/></Box>
                     }
                 </div>
             </div>
            </div>
        </div>
    </div>
};

export default DefaultSpaceUserModeLayout;
